import { Alert } from "@mui/material";
import { isAxiosError } from "axios";
import { isEmpty } from "es-toolkit/compat";

import type { RequestValidationError } from "@dfp/isomorphic-api-sdk";

import {
  Error401Content,
  Error404Content,
  Error500Content,
  ErrorUnreachableServerContent,
} from "../errorPages/index.ts";
import {
  isPlatformRequestError,
  isRequestValidationFailedError,
  useTranslateGenericError,
} from "../errors/index.ts";

type SplashErrorProps = {
  error: Error;
};

export function SplashError({ error }: SplashErrorProps) {
  const translateGenericError = useTranslateGenericError();

  if (isPlatformRequestError(error, 400, undefined, "DocumentNotFound")) {
    return <Error404Content />;
  }

  if (
    isPlatformRequestError(error, 401) ||
    isPlatformRequestError(error, 400, "EntitlementError") ||
    isRequestorIdentityPartyRoleTypeError(error)
  ) {
    return <Error401Content />;
  }

  if (isPlatformRequestError(error, 500)) {
    return <Error500Content />;
  }

  if (isAxiosError(error) && !error.response) {
    return <ErrorUnreachableServerContent />;
  }

  return <Alert severity="error">{translateGenericError(error)}</Alert>;
}

function isRequestorIdentityPartyRoleTypeError(err: Error) {
  return (
    isRequestValidationFailedError(err) &&
    !isEmpty(
      err.response?.data?.errorAttributes?.find(
        (validationError: RequestValidationError) =>
          validationError.code === "InvalidEnumValue" &&
          validationError.path ===
            "requestorIdentity.requestor.partyRoleReference.partyRoleType",
      ),
    )
  );
}
